import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import "./OrderDetailsModalDialog.scss";
import getStyles from "./getStyles";
import moment from "moment";
import {
  Backdrop,
  Box,
  CircularProgress,
  Tab,
  Tooltip,
  Typography
} from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import Tabs from "@material-ui/core/Tabs";
import convertOrderStatusToStatusDescription from "../../utils/convertOrderStatusToStatusDescription";

const OrderDetailsModalDialog = (props: any) => {
  const classes = getStyles();
  const [value, setValue] = React.useState(0);
  const [
    openCancellationConfirmationDialog,
    setOpenCancellationConfirmationDialog
  ] = React.useState(false);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const { openOrderResultsModal, onOpenOrderResultsModal } = props;

  useEffect(() => {
    if (openOrderResultsModal && onOpenOrderResultsModal) {
      onOpenOrderResultsModal();
    }
  }, [openOrderResultsModal, onOpenOrderResultsModal]);

  function handleClickAuthorise() {
    props.onAuthorise({
      orderId: props.data.id,
      version: props.data.version
    });
    props.onClose();
  }

  function handleClickCancelOrder() {
    props.onCancelOrder(props.data.type, { version: props.data.version });
    props.onClose();
  }

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }

  const settlementCurrencyCode =
    props.data && props.data.settlementSource == 1
      ? `${props.data.currencyCode} `
      : "£";

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        className="OrderDetailsModalDialog"
        open={props.open || false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.titleBar}>
          {props.data && props.data.type === "Order"
            ? "Order Number: "
            : "Return Number: "}
          {props.data && props.data.id}
        </DialogTitle>
        <DialogContent>
          <div className={`${classes.root}`}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab
                className={`${classes.tabLabel} OrderDetails-detailsTab`}
                label="Details"
              />
              <Tab
                className={`${classes.tabLabel} OrderDetails-auditHistoryTab`}
                label={`Audit History (${
                  props.data && props.data.auditHistory
                    ? props.data.auditHistory.length
                    : 0
                })`}
              />
            </Tabs>
            <TabPanel value={value} index={0}>
              <>
                {!props.isLoadingOrder ? (
                  <div className="OrderDetailsModalDialog--container">
                    <div className="OrderDetailsModalDialog--detailsContainer">
                      <div className="OrderDetailsModalDialog--detailsLeft">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Date Placed:
                          </p>
                          {props.data && props.data.dateOrdered && (
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-dateOrdered">
                              {moment(props.data.dateOrdered).format(
                                "DD/MM/YYYY"
                              )}{" "}
                            </p>
                          )}
                        </div>
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Date Required:
                          </p>
                          {props.data && props.data.dateRequired && (
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-dateRequired">
                              {moment(props.data.dateRequired).format(
                                "DD/MM/YYYY"
                              )}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="OrderDetailsModalDialog--detailsMiddle">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Currency:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-currency">
                            {props.data &&
                              props.data.currency &&
                              props.data.currency}
                          </p>
                        </div>
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Currency Amount:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-currencyAmount">
                            {props.data &&
                              props.data.currencyAmount &&
                              props.data.currencyAmount.toLocaleString(
                                navigator.language,
                                {
                                  minimumFractionDigits: 2
                                }
                              )}
                          </p>
                        </div>
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Exchange Rate:
                          </p>

                          <div className="OrderDetailsModalDialog--itemWithIndicatorContainer">
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-exchangeRate">
                              {props.data &&
                                props.data.exchangeRate &&
                                props.data.exchangeRate.toLocaleString(
                                  navigator.language,
                                  {
                                    minimumFractionDigits: 4
                                  }
                                )}
                            </p>
                            <div>
                              {props.data &&
                              props.data.status &&
                              props.data.status === "Ordered" ? (
                                <Tooltip title="Indicative rate only">
                                  <WarningIcon className="OrderDetailsModalDialog--indicativeWarningIcon"></WarningIcon>
                                </Tooltip>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="OrderDetailsModalDialog--detailsRight">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Price:
                          </p>
                          <div className="OrderDetailsModalDialog--itemWithIndicatorContainer">
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-price">
                              {props.data &&
                                props.data.price &&
                                `${settlementCurrencyCode}${props.data.price.toLocaleString(
                                  navigator.language,
                                  {
                                    minimumFractionDigits: 2
                                  }
                                )}`}
                            </p>
                            <div>
                              {props.data &&
                              props.data.status &&
                              props.data.status === "Ordered" ? (
                                <Tooltip title="Price based on indicative rate">
                                  <WarningIcon className="OrderDetailsModalDialog--indicativeWarningIcon"></WarningIcon>
                                </Tooltip>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Fees:
                          </p>
                          <div className="OrderDetailsModalDialog--itemWithIndicatorContainer">
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-fees">
                              {props.data &&
                                props.data.fees != null &&
                                `${settlementCurrencyCode}${props.data.fees &&
                                  props.data.fees.toLocaleString(
                                    navigator.language,
                                    {
                                      minimumFractionDigits: 2
                                    }
                                  )}`}
                            </p>
                          </div>
                        </div>
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Total:
                          </p>
                          <div className="OrderDetailsModalDialog--itemWithIndicatorContainer">
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-total">
                              {props.data &&
                                props.data.total &&
                                `${settlementCurrencyCode}${props.data.total.toLocaleString(
                                  navigator.language,
                                  {
                                    minimumFractionDigits: 2
                                  }
                                )}`}
                            </p>
                            <div>
                              {props.data &&
                              props.data.status &&
                              props.data.status === "Ordered" ? (
                                <Tooltip title="Fee based on indicative rate">
                                  <WarningIcon className="OrderDetailsModalDialog--indicativeWarningIcon"></WarningIcon>
                                </Tooltip>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="OrderDetailsModalDialog--deliveryDetailsContainer">
                      <div className="OrderDetailsModalDialog--detailsLeft">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Traveller Name:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-travellerName">
                            {props.data && props.data.travellerName}
                          </p>
                        </div>
                        {props.data && props.data.denominations && (
                          <div className="OrderDetailsModalDialog--itemContainer">
                            <p className="OrderDetailsModalDialog--itemLabel">
                              Denominations:
                            </p>
                            <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-denominations">
                              {props.data && props.data.denominations}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="OrderDetailsModalDialog--detailsMiddle">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Delivery Address:
                          </p>
                          <div className="OrderDetailsModalDialog--deliveryAddressContainer OrderDetailsModalDialog--itemValue">
                            <div>
                              {props.data &&
                                props.data.branch &&
                                props.data.branch.streetAddress}
                            </div>
                            <div>
                              {props.data &&
                                props.data.branch &&
                                props.data.branch.city}
                            </div>
                            <div>
                              {props.data &&
                                props.data.branch &&
                                props.data.branch.county}
                            </div>
                            <div>
                              {props.data &&
                                props.data.branch &&
                                props.data.branch.postCode}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="OrderDetailsModalDialog--detailsRight">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Delivery Contact Name:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-contactName">
                            {props.data &&
                              props.data.branch &&
                              props.data.branch.contactName}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="OrderDetailsModalDialog--otherDetailsContainer">
                      <div className="OrderDetailsModalDialog--detailsLeft">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Status:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-status">
                            {props.data &&
                              props.data.status &&
                              convertOrderStatusToStatusDescription(
                                props.data.status
                              )}
                          </p>
                        </div>
                        {/*<div className="OrderDetailsModalDialog--itemContainer">*/}
                        {/*<p className="OrderDetailsModalDialog--itemLabel">Company:</p>*/}
                        {/*<p className="OrderDetailsModalDialog--itemValue">*/}
                        {/*{props.data.company && props.data.company}*/}
                        {/*</p>*/}
                        {/*</div>*/}
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Branch:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-branchName">
                            {props.data &&
                              props.data.branch &&
                              props.data.branch.name}
                          </p>
                        </div>
                      </div>
                      <div className="OrderDetailsModalDialog--detailsMiddle">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Raised By:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-raisedBy">
                            {props.data &&
                              props.data.raisedBy &&
                              `${props.data.raisedBy.firstName || ""} ${props
                                .data.raisedBy.lastName || ""}`}
                          </p>
                        </div>
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Authoriser:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-authorisedBy">
                            {props.data &&
                              props.data.authorisedBy &&
                              `${props.data.authorisedBy.firstName ||
                                ""} ${props.data.authorisedBy.lastName || ""}`}
                          </p>
                        </div>
                      </div>
                      <div className="OrderDetailsModalDialog--detailsRight">
                        <div className="OrderDetailsModalDialog--itemContainer">
                          <p className="OrderDetailsModalDialog--itemLabel">
                            Processed By:
                          </p>
                          <p className="OrderDetailsModalDialog--itemValue OrderDetailsModalDialog-processedBy">
                            {props.data && props.data.processedBy
                              ? `${props.data.processedBy.firstName ||
                                  ""} ${props.data.processedBy.lastName || ""}`
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <Backdrop className={classes.backdrop} open={true}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}
              </>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <table className="AuditHistoryTable-container">
                <thead className="AuditHistoryTable--headPanel">
                  <tr className="AuditHistoryTable--headPanelRow">
                    <th>Date</th>
                    <th>User</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data &&
                    props.data.auditHistory &&
                    props.data.auditHistory.map((item: any) => (
                      <tr className="AuditHistoryTable--row">
                        <td className="AuditHistoryTable-date">
                          {moment(item.date).format("DD/MM/YYYY HH:mm:ss")}
                        </td>
                        <td className="AuditHistoryTable-user">
                          {item.user && item.user.firstName}{" "}
                          {item.user && item.user.lastName}
                        </td>
                        <td className="AuditHistoryTable-description">
                          {item.description}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </TabPanel>
          </div>
        </DialogContent>
        <DialogActions>
          {props.data &&
            props.permissions &&
            props.permissions.cancelling &&
            props.data.status !== "Cancelled" &&
            props.data.status !== "UploadingToIntrafin" &&
            props.data.status !== "Dispatched" && (
              <Button
                className="OrderDetailsModalDialog-cancelOrderButton"
                onClick={() => setOpenCancellationConfirmationDialog(true)}
              >
                Cancel {props.data.type === "Order" ? "Order" : "Return"}
              </Button>
            )}
          {props.data && props.data.status === "RequiresAuthorisation" ? (
            <Button
              color="primary"
              className="OrderDetailsModalDialog-authorise-button"
              onClick={handleClickAuthorise}
            >
              Authorise
            </Button>
          ) : (
            <></>
          )}

          {props.permissions &&
          props.permissions.processing &&
          props.data &&
          ((props.data.status === "Ordered" && props.data.type === "Order") ||
            (props.data.status === "AwaitingProcessing" &&
              props.data.type === "Return")) ? (
            <Button
              className="OrderDetailsModalDialog-process-button"
              color="primary"
              onClick={() => props.onProcess()}
            >
              Process
            </Button>
          ) : (
            <></>
          )}
          <Button
            className="OrderDetailsModalDialog-close-button"
            color="secondary"
            onClick={props.onClose}
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        className="OrderHistoryTable-cancellationConfirmation"
        open={openCancellationConfirmationDialog}
        onClose={() => {
          setOpenCancellationConfirmationDialog(false);
        }}
      >
        <DialogTitle>Cancellation</DialogTitle>
        <DialogContent>
          <div className="CancellationConfirmationDialog-message">
            Do you want to cancel this{" "}
            {props.data && props.data.type === "Order" ? "order" : "return"}?
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="CancellationConfirmationDialog-cancelButton"
            onClick={() => setOpenCancellationConfirmationDialog(false)}
          >
            Cancel
          </Button>
          <Button
            className="CancellationConfirmationDialog-okButton"
            color="primary"
            onClick={() => {
              handleClickCancelOrder();
              setOpenCancellationConfirmationDialog(false);
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderDetailsModalDialog;
